/* eslint-disable no-param-reassign */
import { isArray, keys, map, isEmpty, object, filter, each, extend } from 'underscore';
import { Predicate } from './predicate';

function isQueryExpressionValid(queryExpression, filterSchema) {
  const propertyKey = keys(queryExpression)[0];
  let isValid = false;
  const property = filterSchema.filterProps()[propertyKey];

  if (!property) {
    each(filterSchema.filterProps(), (value, key) => {
      if (propertyKey === value.originalProperty) {
        queryExpression[key] = queryExpression[propertyKey];
        delete queryExpression[propertyKey];
        isValid = true;
      }
    });
  } else {
    isValid = true;
  }
  return isValid;
}

export function convertFilterEntityToExpressions(filterEntity) {
  const queryExpressions = [];

  if (!filterEntity) {
    return queryExpressions;
  }

  if (filterEntity.depth > 2) {
    throw new Error('Filter control doesn\'t support expression trees of depth > 2');
  }
  if (filterEntity.depth === 1) {
    queryExpressions.push(filterEntity.query);
  } else if (filterEntity.depth > 1) {
    if (isArray(filterEntity.query.$and)) {
      queryExpressions.push(...filterEntity.query.$and);
    }
    if (isArray(filterEntity.query.$or)) {
      queryExpressions.push(...filterEntity.query.$or);
    }
  }

  return filter(
    queryExpressions,
    queryExpression => isQueryExpressionValid(queryExpression, filterEntity.schema)
  );
}

export function convertExpressionsToQuery(expressions) {
  let query;

  if (isEmpty(expressions)) {
    query = {};
  } else if (expressions.length === 1) {
    [query] = expressions;
  } else {
    query = object(['$and'], [expressions]);
  }

  return query;
}

export function convertPredicatesToQuery(predicates) {
  const queryExpressions = map(predicates, predicate => predicate.toQuery());
  return convertExpressionsToQuery(queryExpressions);
}

export function getValidFilterEntity(filterEntity) {
  const validExpressions = convertFilterEntityToExpressions(filterEntity);
  const validQuery = convertExpressionsToQuery(validExpressions);
  if (isEmpty(validQuery)) {
    return null;
  }
  filterEntity.updateQuery(validQuery);
  return filterEntity;
}

export function convertFilterEntityToPredicates(filterEntity) {
  return convertFilterEntityToExpressions(filterEntity)
    .map(queryExpression => Predicate.fromQueryExpression({
      query: queryExpression,
    }))
    .map((editablePredicate) => {
      const { properties } = filterEntity.schema.entitySchema;
      if (editablePredicate.property in properties) {
        if (properties[editablePredicate.property].isDeletedProperty) {
          return extend(editablePredicate, {
            isDeletedProperty: true,
          });
        }

        if (properties[editablePredicate.property].isInvalidProperty) {
          return extend(editablePredicate, {
            isInvalidProperty: true,
          });
        }
      }

      return editablePredicate;
    });
}
